import { render, staticRenderFns } from "./RidgeComponent.vue?vue&type=template&id=398863fc&scoped=true&"
import script from "./RidgeComponent.vue?vue&type=script&lang=js&"
export * from "./RidgeComponent.vue?vue&type=script&lang=js&"
import style0 from "./RidgeComponent.vue?vue&type=style&index=0&id=398863fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398863fc",
  null
  
)

export default component.exports